import { z } from 'zod';

import { OptionalVendorDeviceMetaSchema } from '../../../components/vendorDevice';

const LimitSchema = z.object({
  enabled: z.boolean(),
  value: z.number(),
});

const WindowLimitSchema = z.object({
  enabled: z.boolean(),
  value: z.number(),
  windowSeconds: z.number(),
});

const SwitchesSchema = z.object({
  showTokenLimit: z.boolean().default(false),
  showRequests: z.boolean().default(false),
  showInputTokens: z.boolean().default(false),
  showOutputTokens: z.boolean().default(false),
});

/** 模型订阅交付规格：与创建页 ModelSubscriptionPayload 对齐 */
export const MsSpecSchema = z.object({
  alias: z.string().default(''),
  description: z.string().optional(),
  workspace: z.string().optional(),
  creator: z.string().optional(),
  allowedClientCIDRs: z.array(z.string()).default([]),
  allowedClientIPs: z.array(z.string()).default([]),
  strategyName: z.string().optional(),
  /** 仅 UI 展示：直建为上游模型（customModelID）；计价为供应商展示名 */
  strategyDisplayName: z.string().optional(),
  /** 仅 UI 展示：直建弹窗中的模型供应商（spec.provider），不提交 API */
  strategyProvider: z.string().optional(),
  /** 计价厂商设备元数据，仅用于询价 resourceConfigs，不提交 API */
  providerPricing: OptionalVendorDeviceMetaSchema,
  /** 计价模式：所选计费项是否子资源计价（UI 态，不提交 API） */
  useSubResourcePricing: z.boolean().optional(),
  llmgwStrategyRef: z
    .object({
      external: z.object({
        strategyName: z.string(),
      }),
    })
    .optional(),
  rateLimits: z
    .object({
      inputTokens: WindowLimitSchema,
      outputTokens: WindowLimitSchema,
    })
    .optional(),
  resourceLimits: z
    .object({
      billingTotalTokens: LimitSchema,
      inputTokens: LimitSchema,
      outputTokens: LimitSchema,
      requests: LimitSchema,
    })
    .optional(),
  switches: SwitchesSchema.default({
    showTokenLimit: false,
    showRequests: false,
    showInputTokens: false,
    showOutputTokens: false,
  }),
});

export type MsSpec = z.infer<typeof MsSpecSchema>;

export type MsApiPayload = {
  alias: string;
  workspace: string;
  allowedClientCIDRs?: string[];
  allowedClientIPs?: string[];
  creator: string;
  description: string;
  llmgwStrategyRef: {
    external: {
      strategyName: string;
    };
  };
  rateLimits: NonNullable<MsSpec['rateLimits']>;
  resourceLimits: NonNullable<MsSpec['resourceLimits']>;
} & Record<string, unknown>;
